<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Customers</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        @for (customer of customers; track $index) {
        <ion-item [disabled]="vb.disabled">
            <ion-label class="ion-text-wrap">
                <span class="line1">{{customer.customerName}}</span><br />
                <span class="line2">{{getMaskedPhoneNumber(customer)}}</span><br />
                <span class="line2">isActive: {{customer.isActive}}</span><br />
                <span class="line2">Last Shuttle Date: {{getLastShuttleDate(customer)}}</span>
            </ion-label>
            <!-- <ion-checkbox slot="end" (ionChange)="onCustomerSelectedClick(customer)"></ion-checkbox> -->
        </ion-item>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <!-- <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled (click)="onAddClick()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab> -->
</ion-footer>